var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 47,
    viewBox: "0 0 301 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.049 16.0572C259.049 17.9784 264.347 18.2387 271.205 18.5645C283.393 19.1831 300.522 20.0297 300.49 31.0027C300.49 43.5056 286.188 46.4689 270.847 46.4689C255.538 46.4359 242.83 44.5801 241.205 31.0027H259.049C260.999 34.3889 265.517 35.2679 270.847 35.2679C276.145 35.2679 282.646 34.3889 282.646 31.0027C282.646 29.0815 277.348 28.7881 270.49 28.463C258.301 27.8438 241.172 26.9972 241.205 16.0572C241.205 3.55369 255.506 0.55838 270.847 0.55838C286.156 0.656056 298.864 2.38196 300.49 16.0572H282.646C280.696 12.6055 276.178 11.792 270.847 11.792C265.549 11.792 259.049 12.5732 259.049 16.0572Z",
    fill: "#002163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.43 45.4591V1.69798H236.557V12.899H202.462V18.4991H236.557V28.6256H202.462V34.2257H236.557V45.4591H185.43Z",
    fill: "#002163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.485 1.63257H145.517V31.5234H179.612V45.3943H128.485V1.63257Z",
    fill: "#002163"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 16.0572C18.3337 17.9784 23.6317 18.2387 30.4897 18.5645C42.6783 19.1831 59.8072 20.0297 59.7747 31.0027C59.7747 43.5056 45.4735 46.4689 30.1323 46.4689C14.8235 46.4359 2.11493 44.5801 0.489792 31.0027H18.3337C20.2839 34.3889 24.8018 35.2679 30.1323 35.2679C35.4302 35.2679 41.9307 34.3889 41.9307 31.0027C41.9307 29.0815 36.6328 28.7881 29.7747 28.463C17.5862 27.8438 0.457289 26.9972 0.489792 16.0572C0.489792 3.55369 14.791 0.55838 30.1323 0.55838C45.441 0.656056 58.1495 2.38196 59.7747 16.0572H41.9307C39.9806 12.6055 35.4627 11.792 30.1323 11.792C24.8343 11.792 18.3337 12.5732 18.3337 16.0572Z",
    fill: "#002163"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.597 7.07334L94.3021 10.4787L93.2491 10.7702L94.0231 11.5393L96.4252 13.9329L94.3699 16.0229L93.6085 14.3673L91.4417 19.0186L66.0276 44.9803L65.5572 45.4578H60.0347L83.4678 1.69672H103.718L106.597 7.07334ZM127.151 45.4578H107.978L104.529 37.9721H82.6563L79.2145 45.4578H75.277L92.3641 27.2919H99.5887L97.2056 22.1445L100.815 18.3118L103.186 20.6807L103.966 21.4561L104.244 20.3892L107.34 8.45656L127.151 45.4578Z",
    fill: "#002163"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.893 7.65443L103.629 20.2253L100.798 17.4017L74.4327 45.4216H66.4766L97.3186 13.931L94.4677 11.0864L106.893 7.65443Z",
    fill: "url(#paint0_linear_1469_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1469_3",
    x1: 66.4766,
    y1: 26.538,
    x2: 106.893,
    y2: 26.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#396BE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DD0D89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5413"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOnly);
export default __webpack_public_path__ + "static/media/SalesOnly.2dd5c884365edc096801c4ba385b5c12.svg";
export { ForwardRef as ReactComponent };